/* src/app/home-new/uploading-files-modal/uploading-files-modal.component.scss */
.inner-content {
  padding: 30px;
}
ion-label {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 10px;
}
ion-button {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
ion-icon {
  width: 24px;
  height: 24px;
}
ion-icon.title-icon {
  width: 30px;
  height: 30px;
}
.title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 24px;
  font-weight: 500;
}
hr {
  margin-top: 30px;
  margin-bottom: 30px;
  border-top: 1px solid #cbcbcb;
}
.label {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.progress-bar-container {
  height: 20px;
  border: 1px solid #cbcbcb;
  background-color: #f6f6f6;
  border-radius: 100px;
  margin-bottom: 15px;
  overflow: hidden;
  position: relative;
}
.progress-bar-container.is-pending::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.6),
      transparent);
  animation: shimmer 2s infinite;
}
.progress-bar-container .progress-bar {
  height: 100%;
  background-color: #43c0f6;
  border-radius: 100px;
  transition: width 0.3s ease-in-out;
  background-color: #43c0f6;
  background-image:
    repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.25) 0,
      rgba(255, 255, 255, 0.25) 25px,
      transparent 25px,
      transparent 50px);
  background-size: 200% 200%;
  animation: animate-stripes 4s linear infinite;
}
.progress-bar-container .progress-bar.completed {
  background-image: none;
  background-color: #0acf83;
}
@keyframes animate-stripes {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: 0 0;
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.progressText {
  color: #949494;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 600;
}
/*# sourceMappingURL=uploading-files-modal.component-5F3ZJYMH.css.map */
